import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import FitSyncLogo from './FitSyncLogo';
import { FiMonitor, FiBell, FiShield, FiCpu, FiInfo, FiExternalLink } from 'react-icons/fi';

export default function Settings() {
  const sections = [
    { icon: FiMonitor, title: 'Interface Preferences', desc: 'Theme, telemetry overlays, and kinetic card animations.' },
    { icon: FiBell, title: 'Alert Protocols', desc: 'Configure coach uplinks, recovery thresholds, and system pings.' },
    { icon: FiShield, title: 'Data Encryption', desc: 'Manage local biometric storage and node sync permissions.' },
    { icon: FiCpu, title: 'Neural Integration', desc: 'Connect supported wearables and biometric sensor arrays.' },
  ];

  return (
    <div className="max-w-4xl mx-auto space-y-12 pb-20">
      <div>
        <h2 className="text-3xl font-bold text-white tracking-tighter mb-2">SYSTEM.PREFERENCES</h2>
        <p className="text-gray-500 font-mono text-sm uppercase tracking-widest">Global Configuration Layer</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {sections.map((sec, i) => (
          <motion.div 
            key={i} 
            whileHover={{ y: -4, backgroundColor: 'rgba(255,255,255,0.02)' }}
            className="glass-panel p-6 cursor-pointer group border-carbon-700/50"
          >
            <div className="flex items-start gap-4">
              <div className="p-3.5 rounded-xl bg-carbon-900 border border-carbon-700 group-hover:border-lime-500 group-hover:text-lime-500 transition-all duration-300 text-gray-500">
                <SafeIcon icon={sec.icon} className="text-xl" />
              </div>
              <div>
                <h3 className="text-white font-bold mb-1 group-hover:text-lime-500 transition-colors">{sec.title}</h3>
                <p className="text-xs text-gray-500 leading-relaxed">{sec.desc}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="glass-panel p-10 relative overflow-hidden text-center border-dashed border-carbon-700">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-lime-500/20 to-transparent" />
        
        <div className="inline-flex items-center justify-center p-6 rounded-3xl bg-carbon-900 border border-carbon-700 mb-8 shadow-2xl relative">
          <FitSyncLogo className="w-16 h-16 opacity-80" />
          <div className="absolute -inset-1 bg-lime-500/5 blur-xl rounded-full" />
        </div>

        <h3 className="text-white font-mono font-bold text-xl mb-3 tracking-tighter">FITSYNC LAB <span className="text-lime-500">v2.0.4-BETA</span></h3>
        <p className="text-sm text-gray-500 max-w-md mx-auto mb-10 leading-relaxed font-mono uppercase text-[10px] tracking-widest">
          Performance control interface operating optimally. All local systems are green. No external medical claims are made by this software.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-10 border-t border-carbon-800">
          <div className="flex items-center gap-2 px-4 py-2 bg-carbon-900 rounded-lg border border-carbon-700 text-[10px] font-mono text-gray-500">
            <SafeIcon icon={FiInfo} className="text-lime-500" />
            BUILD_ID: 982-AX-24
          </div>
          <a href="#" className="flex items-center gap-2 px-4 py-2 hover:bg-carbon-700 rounded-lg transition-colors text-[10px] font-mono text-white uppercase tracking-widest">
            Documentation <SafeIcon icon={FiExternalLink} />
          </a>
        </div>

        {/* Required Credit Line */}
        <div className="mt-12 opacity-40 hover:opacity-100 transition-opacity">
          <p className="text-[10px] font-mono text-gray-600 uppercase tracking-[0.5em] font-bold">
            Made by LingLink AI and DigLab AI
          </p>
        </div>
      </div>
    </div>
  );
}